var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"o-otg-start-tiles",style:(_vm.styles)},_vm._l((_vm.categories),function(category){return _c('router-link',{key:category.id,staticClass:"otg-start-tiles-button",attrs:{"to":{
            name: category.redirect.name,
            params: {
                categoryId: category.redirect.categoryId,
                path: category.redirect.path
            }
        },"tag":"button"}},[_c('span',{staticClass:"otg-start-tiles-container"},[_c('img',{staticClass:"otg-start-tiles-icon",attrs:{"src":category.icon,"alt":category.altText}}),_c('span',{staticClass:"otg-start-tiles-title"},[_vm._v(" "+_vm._s(_vm.$t(category.title))+" ")])])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }